module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body infodd"
  }, [_c('div', {
    staticClass: "page intada",
    staticStyle: {
      "position": "relative"
    }
  }, [
    [_vm._m(0), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "box-qyry"
    }, [_c('div', {
      staticClass: "box-title"
    }, [_vm._v("企业荣誉")]), _vm._v(" "), _c('div', {
      staticClass: "qyry-wen"
    }, [_c('div', {
      staticClass: "flex-sub qyry-wen-text",
      staticStyle: {
        "margin-bottom": "0.03rem"
      }
    }, [_c('img', {
      staticClass: "icon-bd",
      attrs: {
        "src": require("../../assets/image/icon-bd.png")
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t近三年国家科技型中小企业总数:"), _c('span', [_vm._v(_vm._s(_vm.detailtt.keji_count))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-sub qyry-wen-text",
      staticStyle: {
        "margin-bottom": "0.03rem"
      }
    }, [_c('img', {
      staticClass: "icon-bd",
      attrs: {
        "src": require("../../assets/image/icon-bd.png")
      }
    }), _vm._v("高新技术企业:"), _c('span', [_vm._v(_vm._s(_vm.detailtt.gaoxin_count))])]), _vm._v(" "), _c('div', {
      staticClass: "margin-bottom qyry-wen-text"
    }, [_c('img', {
      staticClass: "icon-bd",
      attrs: {
        "src": require("../../assets/image/icon-bd.png")
      }
    }), _vm._v("“专精特新”企业\n\t\t\t\t\t\t\t\t市级/省级:"), _c('span', [_vm._v(_vm._s(_vm.detailtt.zhuanjing_count_city) + "/" + _vm._s(_vm.detailtt.zhuanjing_count_province))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("郑州市近三年增长情况")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
      staticClass: "center"
    }, [_c('div', {
      staticClass: "box-qitu"
    }, [(_vm.building1Action + 1 > 0) ? _c('div', {
      staticClass: "building-tools"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.building1Action + 1) + "楼\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "box-jcxx-title"
    }, [_vm._v("企业基础信息")]), _vm._v(" "), _c('div', {
      staticClass: "building-box"
    }, [_c('img', {
      staticClass: "building-bg",
      attrs: {
        "src": require("../../assets/image/building.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-building1",
      on: {
        "mouseleave": _vm.mouseleavechange
      }
    }, [
      [_c('div', {
        staticClass: "box-building1-left"
      }, [_vm._l((21), function(item, index) {
        return [(index > 2) ? _c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.oneindex == index
          },
          style: ({
            top: 0.092 * (17 - 1 - index + 3) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 1)
            },
            "click": function($event) {
              return _vm.foolclick(index, 1)
            }
          }
        }) : _vm._e()]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "box-building1-right"
      }, [_vm._l((21), function(item, index) {
        return [(index > 2) ? _c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.oneindex == index
          },
          style: ({
            top: 0.063 * (17 - 1 - index + 3) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 1)
            },
            "click": function($event) {
              return _vm.foolclick(index, 1)
            }
          }
        }) : _vm._e()]
      })], 2)], _vm._v(" "), [_c('div', {
        staticClass: "box-building1-d-left"
      }, [_vm._l((3), function(item, index) {
        return [_c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.oneindex == index
          },
          style: ({
            top: 0.075 * (2 - index) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 1)
            },
            "click": function($event) {
              return _vm.foolclick(index, 1)
            }
          }
        })]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "box-building1-d-right"
      }, [_vm._l((3), function(item, index) {
        return [_c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.oneindex == index
          },
          style: ({
            top: 0.054 * (2 - index) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 1)
            },
            "click": function($event) {
              return _vm.foolclick(index, 1)
            }
          }
        })]
      })], 2)]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "box-building2",
      on: {
        "mouseleave": _vm.mouseleavechange
      }
    }, [_c('div', {
      staticClass: "box-building2-01"
    }, [_vm._l((17), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.twoindex == index
        },
        style: ({
          top: 0.085 * (17 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 2)
          },
          "click": function($event) {
            return _vm.foolclick(index, 2)
          }
        }
      })]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "box-building2-02"
    }, [_vm._l((17), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.twoindex == index
        },
        style: ({
          top: 0.088 * (17 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 2)
          },
          "click": function($event) {
            return _vm.foolclick(index, 2)
          }
        }
      })]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "box-building2-03"
    }, [_vm._l((17), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.twoindex == index
        },
        style: ({
          top: 0.168 * (17 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 2)
          },
          "click": function($event) {
            return _vm.foolclick(index, 2)
          }
        }
      })]
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "box-building3",
      on: {
        "mouseleave": _vm.mouseleavechange
      }
    }, [_c('div', {
      staticClass: "box-building3-01"
    }, [_vm._l((17), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.threeindex == index
        },
        style: ({
          top: 0.105 * (17 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 3)
          },
          "click": function($event) {
            return _vm.foolclick(index, 3)
          }
        }
      })]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "box-building3-02"
    }, [_vm._l((17), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.threeindex == index
        },
        style: ({
          top: 0.09 * (17 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 3)
          },
          "click": function($event) {
            return _vm.foolclick(index, 3)
          }
        }
      })]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "box-building3-03"
    }, [_vm._l((17), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.threeindex == index
        },
        style: ({
          top: 0.09 * (17 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 3)
          },
          "click": function($event) {
            return _vm.foolclick(index, 3)
          }
        }
      })]
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "box-building4",
      on: {
        "mouseleave": _vm.mouseleavechange
      }
    }, [
      [_c('div', {
        staticClass: "box-building4-01"
      }, [_vm._l((26), function(item, index) {
        return [(index > 2) ? _c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.fourindex == index
          },
          style: ({
            top: 0.08 * (17 - 1 - index) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 4)
            },
            "click": function($event) {
              return _vm.foolclick(index, 4)
            }
          }
        }) : _vm._e()]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "box-building4-02"
      }, [_vm._l((26), function(item, index) {
        return [(index > 2) ? _c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.fourindex == index
          },
          style: ({
            top: 0.09 * (17 - 1 - index) + 'rem',
            marginLeft: index > 14 ? (0.02 * (index - 14) + 'rem') : 0,
            width: index > 14 ? (0.61 - (0.02 * (index - 14)) + 'rem') : '0.61rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 4)
            },
            "click": function($event) {
              return _vm.foolclick(index, 4)
            }
          }
        }) : _vm._e()]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "box-building4-03"
      }, [_vm._l((26), function(item, index) {
        return [(index > 2) ? _c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.fourindex == index
          },
          style: ({
            top: 0.068 * (17 - 1 - index) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 4)
            },
            "click": function($event) {
              return _vm.foolclick(index, 4)
            }
          }
        }) : _vm._e()]
      })], 2)], _vm._v(" "), [_c('div', {
        staticClass: "box-building4-d-01"
      }, [_vm._l((3), function(item, index) {
        return [_c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.fourindex == index
          },
          style: ({
            top: 0.1 * (17 - 1 - index) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 4)
            },
            "click": function($event) {
              return _vm.foolclick(index, 4)
            }
          }
        })]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "box-building4-d-02"
      }, [_vm._l((3), function(item, index) {
        return [_c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.fourindex == index
          },
          style: ({
            top: 0.12 * (17 - 1 - index) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 4)
            },
            "click": function($event) {
              return _vm.foolclick(index, 4)
            }
          }
        })]
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "box-building4-d-03"
      }, [_vm._l((3), function(item, index) {
        return [_c('div', {
          staticClass: "box-storey",
          class: {
            action: _vm.fourindex == index
          },
          style: ({
            top: 0.09 * (17 - 1 - index) + 'rem'
          }),
          on: {
            "mouseenter": function($event) {
              return _vm.mouseenterchange(index, 4)
            },
            "click": function($event) {
              return _vm.foolclick(index, 4)
            }
          }
        })]
      })], 2)]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "box-building7",
      on: {
        "mouseleave": _vm.mouseleavechange
      }
    }, [_c('div', {
      staticClass: "box-building7-01"
    }, [_vm._l((6), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.sevenindex == index
        },
        style: ({
          top: 0.088 * (6 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 7)
          },
          "click": function($event) {
            return _vm.foolclick(index, 7)
          }
        }
      })]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "box-building7-02"
    }, [_vm._l((6), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.sevenindex == index
        },
        style: ({
          top: 0.1 * (6 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 7)
          },
          "click": function($event) {
            return _vm.foolclick(index, 7)
          }
        }
      })]
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "box-building10",
      on: {
        "mouseleave": _vm.mouseleavechange
      }
    }, [_c('div', {
      staticClass: "box-building10-01"
    }, [_vm._l((3), function(item, index) {
      return [_c('div', {
        staticClass: "box-storey",
        class: {
          action: _vm.zhongindex == index
        },
        style: ({
          top: 0.078 * (3 - 1 - index) + 'rem'
        }),
        on: {
          "mouseenter": function($event) {
            return _vm.mouseenterchange(index, 10)
          },
          "click": function($event) {
            return _vm.foolclick(index, 10)
          }
        }
      })]
    })], 2)])])]), _vm._v(" "), _c('div', {
      staticClass: "box-yqqy"
    }, [_c('div', {
      staticClass: "box-title",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "space-between"
      }
    }, [_vm._v(_vm._s(_vm.qyxxtype ? '企业信息展示' : '园区企业展示'))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#fff",
        "position": "absolute",
        "right": "0.25rem",
        "font-size": "15px",
        "cursor": "pointer",
        "z-index": "99",
        "top": "0.05rem"
      },
      on: {
        "click": function($event) {
          return _vm.jump('/enterprise')
        }
      }
    }, [_vm._v("More")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    }), _vm._v(" "), (!_vm.qyxxtype) ? [_c('el-carousel', {
      staticStyle: {
        "height": "3.1rem",
        "width": "100%",
        "margin": "auto"
      },
      attrs: {
        "arrow": "never"
      }
    }, _vm._l((_vm.qylist), function(item) {
      return _c('el-carousel-item', [_c('div', {
        staticClass: "yqqy-swiper-item"
      }, [_c('div', {
        staticClass: "text-center img",
        staticStyle: {
          "object-fit": "cover"
        }
      }, [_c('img', {
        staticClass: "img",
        attrs: {
          "src": _vm._f("addurl")(item.newimage)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "yqqy-swiper-item-text text-cut2",
        staticStyle: {
          "color": "#fff",
          "font-size": "0.12rem",
          "font-weight": "normal"
        }
      }, [_c('span', [_vm._v(_vm._s(item.content))])])])])
    }), 1)] : [_c('div', {
      staticClass: "my_table",
      staticStyle: {
        "margin": "0.1rem 0.2rem",
        "position": "relative"
      }
    }, [_c('el-table', {
      staticStyle: {
        "height": "2.9rem"
      },
      attrs: {
        "data": _vm.comlist
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "hourse_floor",
        "label": "楼号/楼层",
        "width": "100px"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.hourse_number + '/' + scope.row.hourse_floor + '楼',
              "placement": "top-start"
            }
          }, [_c('div', {
            staticClass: "yinc text-cut2"
          }, [_vm._v(_vm._s(scope.row.hourse_number) + "/" + _vm._s(scope.row.hourse_floor) + "楼")])])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "fang_number",
        "label": "房间号",
        "width": "90px"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.fang_number,
              "placement": "top-start"
            }
          }, [_c('div', {
            staticClass: "yinc text-cut2"
          }, [_vm._v(_vm._s(scope.row.fang_number))])])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "company_name",
        "label": "企业名称"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.company_name,
              "placement": "top-start"
            }
          }, [_c('div', {
            staticClass: "yinc text-cut2"
          }, [_vm._v(_vm._s(scope.row.company_name))])])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "hangye",
        "label": "行业",
        "width": "150"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.hangye,
              "placement": "top-start"
            }
          }, [_c('div', {
            staticClass: "yinc text-cut2"
          }, [_vm._v(_vm._s(scope.row.hangye))])])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "legal",
        "label": "联系人",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.legal,
              "placement": "top-start"
            }
          }, [_c('div', {
            staticClass: "yinc text-cut2"
          }, [_vm._v(_vm._s(scope.row.legal))])])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "phone",
        "label": "联系方式",
        "width": "150"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.phone,
              "placement": "top-start"
            }
          }, [_c('div', {
            staticClass: "yinc text-cut2"
          }, [_vm._v(_vm._s(scope.row.phone))])])]
        }
      }])
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center",
        "position": "absolute",
        "bottom": "0rem"
      }
    }, [_c('el-pagination', {
      attrs: {
        "page-size": 6,
        "pager-count": 5,
        "layout": "prev, pager, next",
        "total": _vm.comnum
      },
      on: {
        "current-change": _vm.qyxxchange
      }
    })], 1)], 1)]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "box-fwpt"
    }, [_c('div', {
      staticStyle: {
        "color": "#fff",
        "position": "absolute",
        "right": "0.25rem",
        "font-size": "15px",
        "cursor": "pointer",
        "z-index": "99"
      },
      on: {
        "click": function($event) {
          return _vm.jump('/servicelist')
        }
      }
    }, [_vm._v("More")]), _vm._v(" "), _c('div', {
      staticClass: "box-title"
    }, [_vm._v("创新服务平台")]), _vm._v(" "), _c('el-carousel', {
      staticStyle: {
        "height": "3.4rem"
      },
      attrs: {
        "arrow": "never"
      }
    }, _vm._l((_vm.detailtt.newservice), function(item) {
      return _c('el-carousel-item', [_c('div', {
        staticClass: "fwpt-swiper-item"
      }, [_c('div', {
        staticStyle: {
          "height": "0.4rem"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "text-center"
      }, [_c('img', {
        staticClass: "img",
        attrs: {
          "src": _vm._f("addurl")(item.image)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "fwpt-swiper-item-text text-cut2",
        staticStyle: {
          "color": "#fff",
          "font-size": "0.12rem",
          "font-weight": "normal"
        }
      }, [_c('span', [_vm._v(_vm._s(item.content))])])])])
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "box-yw"
    }, [_c('div', {
      staticClass: "box-title"
    }, [_vm._v("园区要闻")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#fff",
        "position": "absolute",
        "right": "0.25rem",
        "font-size": "15px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.jump('listpage', 2)
        }
      }
    }, [_vm._v("More")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.3rem"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "yw-list-box"
    }, [_c('el-carousel', {
      attrs: {
        "height": "2.2rem",
        "arrow": "never"
      }
    }, _vm._l((_vm.tableData), function(item) {
      return _c('el-carousel-item', {
        key: item
      }, _vm._l((item), function(eitem, eindex) {
        return _c('div', {
          staticClass: "yw-item",
          on: {
            "click": function($event) {
              return _vm.detailchange('detail', eitem.id, 4)
            }
          }
        }, [_c('div', {
          staticClass: "yw-title cursor-pointer"
        }, [_vm._v(_vm._s(eitem.title) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
          staticClass: "yw-time cursor-pointer"
        }, [_vm._v(_vm._s(eitem.realse_time))])])
      }), 0)
    }), 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "box-yw",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#fff",
        "position": "absolute",
        "right": "0.25rem",
        "font-size": "15px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.jump('bulletinlist')
        }
      }
    }, [_vm._v("More")]), _vm._v(" "), _c('div', {
      staticClass: "box-title"
    }, [_vm._v("政策资讯")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.3rem"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "yw-list-box"
    }, [_c('el-carousel', {
      attrs: {
        "height": "2.2rem",
        "arrow": "never"
      }
    }, _vm._l((_vm.tableData1), function(item) {
      return _c('el-carousel-item', {
        key: item
      }, _vm._l((item), function(eitem, eindex) {
        return _c('div', {
          staticClass: "yw-item",
          on: {
            "click": function($event) {
              return _vm.detailchange('detail', eitem.id, 1)
            }
          }
        }, [_c('div', {
          staticClass: "yw-title cursor-pointer"
        }, [_vm._v(_vm._s(eitem.title) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
          staticClass: "yw-time cursor-pointer"
        }, [_vm._v(_vm._s(eitem.use_start_time))])])
      }), 0)
    }), 1)], 1)])])])]
  ], 2), _vm._v(" "), _c('fooldetailpage', {
    ref: "fooldetailref"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/header.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "tttt",
    staticStyle: {
      "width": "35%",
      "height": "2.6rem",
      "margin-top": "0"
    },
    attrs: {
      "id": "qyryEchart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tttt",
    staticStyle: {
      "width": "60%",
      "height": "2.6rem"
    },
    attrs: {
      "id": "qyryEchart1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-zscq"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("知识产权")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "zscqEchart"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-qyfb"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("企业行业分布")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "qyfbEcharts"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40372ebb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dataview/information.vue
// module id = 890
// module chunks = 1